/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberProfileScanLimitResponse } from '../../models/member-profile-scan-limit-response';

export interface AdminMemberProfileScanLimitPersonIdGet$Params {

/**
 * The person identifier (matches member profile id).
 */
  personId: string;
}

export function adminMemberProfileScanLimitPersonIdGet(http: HttpClient, rootUrl: string, params: AdminMemberProfileScanLimitPersonIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<MemberProfileScanLimitResponse>> {
  const rb = new RequestBuilder(rootUrl, adminMemberProfileScanLimitPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<MemberProfileScanLimitResponse>;
    })
  );
}

adminMemberProfileScanLimitPersonIdGet.PATH = '/Admin/MemberProfileScanLimit/{personId}';
